
const removeDuplicatesObject = (array) => {
    const ids = array?.map(({ id }) => id);
    return array?.filter(({id}, index) => !ids.includes(id, index + 1))
}

export {
    removeDuplicatesObject
};
